import { AppLanguage } from '~/types/locale'
import { Ii18nLocales, Ii18nSanity, Ii18nTranslations } from '~/types/i18n'

import sanityClient from './sanity-client'

async function getI18n(namespaces: string[]): Promise<Ii18nSanity[]> {
  return await sanityClient.fetch(
    `*[_type == "i18n" && namespace in $namespaces]{
        namespace,
        translations[]{ key, en, no }
    }`,
    { namespaces },
  )
}

export async function localesForPlayCanvas(): Promise<Ii18nLocales> {
  const locales = await getI18n(['play-common'])

  const enLocales: Ii18nTranslations = {
    info: {
      locale: AppLanguage.EN,
    },
    messages: {},
  }
  const noLocales: Ii18nTranslations = {
    info: {
      locale: AppLanguage.NO,
    },
    messages: {},
  }

  locales.forEach((namespace) => {
    namespace.translations.forEach((translation) => {
      enLocales.messages[translation.key] = translation.en ?? ''
      noLocales.messages[translation.key] = translation.no ?? ''
    })
  })

  return {
    header: {
      version: 1,
    },
    data: [enLocales, noLocales],
  }
}
